import React, { Component } from "react";

import { isRestaurantOpen } from "../helpers";

import api from "./api";

export const AppContext = React.createContext();

const getAppMode = () => {
  const forcedMode = (process.env.REACT_APP_APP_MODE || "").toLowerCase();
  if (forcedMode === "restaurant" || forcedMode === "delivery") {
    return forcedMode;
  }
  if (typeof window !== "undefined") {
    const hostname = window.location.hostname || "";
    if (hostname.includes("restaurante")) {
      return "restaurant";
    }
  }
  return "delivery";
};

const generateOrderNumber = () =>
  `BAM-${(
    Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
  ).toUpperCase()}`;

const initialAppMode = getAppMode();
const isRestaurantMode = initialAppMode === "restaurant";

const initialState = {
  order: [],
  orderExtra: [],
  user: {},
  orderNumber: generateOrderNumber(),
  total: 0,
  tax: 0,
  deliveryAmount: isRestaurantMode ? 0 : 100,
  serviceFee: 0,
  isRestaurantOpen: isRestaurantMode ? true : isRestaurantOpen(),
  loadingTopBar: false,
  account: {},
  branch: null,
  appMode: initialAppMode,
};

const MENU_TWO_STORAGE_KEY = 'menuTwoSelections';

class AppProvider extends Component {
  state = initialState;

  fetchAccount = async (item) => {
    try {
      const { account } = await api.get("/account/web");
      this.setState({ account: account });
    } catch (err) {
      console.log(err);
    }
  };

  insertContact = (data) => {
    try {
      api.post("/contact/web", data);
    } catch (err) {
      console.log(err);
    }
  };

  setExtraItem = async (item) => {
    await this.setState({ orderExtra: [...item] }, this.updateTotal);
  };
  setLoadingTopBar = (show) => {
    this.setState({ loadingTopBar: show });
  };
  removeItemExtra = async (item) => {
    let extra = [...this.state.orderExtra];

    extra = extra.filter((ex) => {
      return ex.id !== item.id;
    });
    this.setState({ orderExtra: [...extra] }, this.updateTotal);
  };

  componentDidMount = async () => {
    await this.fetchAccount();
    const query = new URLSearchParams(window.location.search);
    const localStorageRef = localStorage.getItem("orderBambanSushi");

    if (localStorageRef) {
      this.setState({ order: JSON.parse(localStorageRef) }, this.updateTotal);
    }

    const localStorageRefExtra = localStorage.getItem("orderExtraBambanSushi");

    if (localStorageRefExtra) {
      this.setState(
        { orderExtra: JSON.parse(localStorageRefExtra) },
        this.updateTotal
      );
    }

    if (this.state.appMode === "restaurant") {
      const sucursal = query.get("sucursal");
      let branch =
        localStorage.getItem("branchRestauranteBamban") ||
        localStorage.getItem("branch") ||
        null;
      if (sucursal) {
        const s = sucursal.toLowerCase();
        if (s === "bellavista") branch = "BAMBAN_BELLA_VISTA";
        else if (s === "naco") branch = "BAMBAN_NACO";
      }
      if (!branch) {
        branch = "BAMBAN_NACO";
      }
      localStorage.setItem("branchRestauranteBamban", branch);
      this.setState({ branch });

      const mesaFromQuery = query.get("mesa");
      if (mesaFromQuery) {
        localStorage.setItem("mesa", mesaFromQuery);
      } else if (!localStorage.getItem("mesa")) {
        const mesa = window.prompt("Numero de mesa", "");
        if (mesa) {
          localStorage.setItem("mesa", mesa);
        }
      }
    } else {
      const branch = localStorage.getItem("branchBambanSushi");
      if (branch) {
        this.setState({ branch });
      }
    }

    // We need to check if the restaurant is open
    this.setState({
      isRestaurantOpen:
        this.state.appMode === "restaurant"
          ? true
          : isRestaurantOpen(this.state.account),
    });
  };

  componentDidUpdate() {
    localStorage.setItem("orderBambanSushi", JSON.stringify(this.state.order));
    localStorage.setItem(
      "orderExtraBambanSushi",
      JSON.stringify(this.state.orderExtra)
    );
    if (this.state.branch) {
      if (this.state.appMode === "restaurant") {
        localStorage.setItem("branchRestauranteBamban", this.state.branch);
      } else {
        localStorage.setItem("branchBambanSushi", this.state.branch);
      }
    }
  }

  addItem = (item) => {
    this.setState((prev) => ({ order: [...prev.order, item] }), this.updateTotal);
  };

  setMenuItemsForMenu = (menuKey, items = []) => {
    this.setState(
      (prev) => {
        const preserved = prev.order.filter((orderItem) => orderItem.menu !== menuKey);
        return { order: [...preserved, ...items] };
      },
      this.updateTotal
    );
  };

  removeItem = (item) => {
    const index = this.state.order.indexOf(item);

    this.setState(
      {
        order: [
          ...this.state.order.slice(0, index),
          ...this.state.order.slice(index + 1),
        ],
      },
      () => {
        if (item?.menu === 'menutwo' && item?.wrapping?.categoryKey && item?.wrapping?.itemName) {
          try {
            const raw = localStorage.getItem(MENU_TWO_STORAGE_KEY);
            if (raw) {
              const parsed = JSON.parse(raw);
              if (parsed?.selected?.[item.wrapping.categoryKey]?.hasOwnProperty(item.wrapping.itemName)) {
                parsed.selected[item.wrapping.categoryKey][item.wrapping.itemName] = false;
                localStorage.setItem(MENU_TWO_STORAGE_KEY, JSON.stringify(parsed));
              }
            }
          } catch (err) {
            // ignore sync failures
          }
        }
        this.updateTotal();
      }
    );
  };

  updateTotal = () => {
    if (this.state.order.length < 1) return;
    const itemTotals = this.state.order.map((order) => order.totalPrice);
    let ExtraTotal = 0;
    this.state.orderExtra.forEach((order) => {
      ExtraTotal += parseFloat(order.quantity) * parseFloat(order.price);
    });
    let total = itemTotals.reduce((prev, index) => prev + index, 0);
    const orderTotalWithoutTax = (total + ExtraTotal) / 1.18;
    const tax = orderTotalWithoutTax * 0.18;
    const serviceFee = orderTotalWithoutTax * 0.1;
    const deliveryAmount =
      this.state.appMode === "restaurant" ? 0 : this.state.deliveryAmount;
    total += deliveryAmount;
    this.setState({
      deliveryAmount,
      total: total + ExtraTotal,
      tax,
      serviceFee,
    });
  };

  addUserData = (user) => {
    if (this.state.appMode === "restaurant") {
      this.setState({ user, deliveryAmount: 0 }, this.updateTotal);
      return;
    }
    let deliveryAmount = 100;
    if (user.takeout) {
      deliveryAmount = 0;
    }
    this.setState({ user, deliveryAmount }, this.updateTotal);
  };

  resetState = () => {
    this.setState(Object.assign({}, initialState, { branch: this.state.branch }));
  };

  setBranch = (branch) => {
    this.setState({ branch });
  };

  render() {
    return (
      <AppContext.Provider
        value={{
          account: this.state.account,
          isRestaurantOpen: this.state.isRestaurantOpen,
          loadingTopBar: this.state.loadingTopBar,
          order: this.state.order,
          orderExtra: this.state.orderExtra,
          user: this.state.user,
          orderNumber: this.state.orderNumber,
          total: this.state.total,
          tax: this.state.tax,
          deliveryAmount: this.state.deliveryAmount,
          serviceFee: this.state.serviceFee,
          branch: this.state.branch,
          appMode: this.state.appMode,
          setMenuItemsForMenu: this.setMenuItemsForMenu,
          insertContact: this.insertContact,
          setLoadingTopBar: this.setLoadingTopBar,
          setExtraItem: this.setExtraItem,
          removeItemExtra: this.removeItemExtra,
          addItem: this.addItem,
          removeItem: this.removeItem,
          addUserData: this.addUserData,
          resetState: this.resetState,
          setBranch: this.setBranch,
        }}
      >
        {this.props.children}
      </AppContext.Provider>
    );
  }
}

export default AppProvider;
